import { useParams } from 'react-router-dom';

import { PageShell } from './_PageShell';

export function TeamDetail() {
  const { id } = useParams<{ id: string }>();
  return (
    <PageShell title={`Team ${id}`} subtitle="Coming soon">
      <p className="text-sm text-hint">Team detail screen — port from mobile-app.</p>
    </PageShell>
  );
}
